import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var isArray = function isArray(item) {
  return Array.isArray(item);
};

var isObj = function isObj(item) {
  return _typeof(item) === 'object';
};

var map = function map(input) {
  if (isArray(input)) {
    return input.reduce(function (acc, item) {
      acc.push(map(item));
      return acc;
    }, []);
  }

  if (isObj(input)) {
    return Object.keys(input).reduce(function (acc, key) {
      acc[key] = map(input[key]);
      return acc;
    }, {});
  }

  return input;
};

export default {
  name: 'ProductSheetTcVars',
  props: {
    tcVars: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    },
    productCross: {
      type: Object,
      default: null
    },
    productCrossComplementary: {
      type: Object,
      default: null
    }
  },
  created: function created() {
    var _this = this;

    this.setTcVars('init product sheet');
    this.$root.$on('reset-tcvars', function () {
      _this.setTcVars('product reset tcVars');
    });
    this.$root.$on('fnClickTracking', function (context, data) {
      _this.fnClickTracking(context, data);
    });
    this.$root.$on('fnClickTrackingVariant', function (context, data) {
      _this.fnClickTrackingVariant(context, data);
    });
    this.$watch('tcVars', function () {
      _this.setTcVars('watcher product tcvars');
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('fnClickTracking');
    this.$root.$off('fnClickTrackingVariant');
  },
  methods: {
    fnClickTracking: function fnClickTracking(context, data) {
      try {
        window.mdm_events(this.tracking.container_id, context.currentTarget, this.tracking[data]['event-type'], this.tracking[data].params);
      } catch (e) {
        console.warn(e);
      }
    },
    fnClickTrackingVariant: function fnClickTrackingVariant(context, data) {
      if (context.currentTarget.value === '') {
        return;
      }

      this.fnClickTracking(context, data);
    },
    setTcVars: function setTcVars(message) {
      if (process.client) {
        this.setCrossWidget('similar');
        this.setCrossWidget('complementary');
      }

      if (process.client && this.$cookies.get('debugmdm')) {
        console.log(message, _objectSpread({}, map(this.tcVars)));
      }

      this.$root.$emit('updated-tcvars', this.tcVars);
    },
    setCrossWidget: function setCrossWidget(widgetType) {
      var cross = widgetType === 'similar' ? this.productCross : this.productCrossComplementary;

      try {
        var widgetId = cross && cross.earlybirdsWidgets ? cross.earlybirdsWidgets.widgetId : null;
        var earlybirdsWidgets = JSON.parse(localStorage.getItem('EARLYBIRDS_WIDGETS')) || {};

        if (widgetId) {
          Object.assign(earlybirdsWidgets, _defineProperty({}, widgetId, cross.earlybirdsWidgets));
          localStorage.setItem('EARLYBIRDS_WIDGETS', JSON.stringify(earlybirdsWidgets));
          this.tcVars.earlybirds_widgets = earlybirdsWidgets;
          if (widgetType === 'similar') this.tcVars.earlybirds_xsell_similaire = widgetId;else if (widgetType === 'complementary') this.tcVars.earlybirds_xsell_complementaire = widgetId;
        }
      } catch (error) {
        if (this.$sentry) {
          this.$sentry.captureMessage(error);
        }
      }
    }
  },
  render: function render(h) {
    return h(null);
  }
};